export default __webpack_public_path__ + "static/media/img11.4c0bcbe0.png";